// Frontend feature flags — quick toggles for surfaces that aren't fully built
// or are intentionally hidden. Flip a value and rebuild to change behavior.
// (Distinct from the firm's subscription `features` in app-data, which are
//  platform-set per tenant; these are product/UI gates.)

export const FEATURES = {
  // Manual "Add company" in the Anti-portfolio. Hidden for now — entries should
  // eventually be generated automatically from passed deals (not yet built).
  // Set to true to expose the manual add form again.
  antiAddCompany: false,
} as const;
